var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"registration"},[_c('div',{staticClass:"registration__background"}),_c('div',{staticClass:"registration__card"},[_c('h1',{staticClass:"white--text text-center"},[_vm._v("Registrace")]),_c('div',{staticClass:"divider"}),_c('RegistrationForm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }